import { useContext } from 'react';
import { ErrorsContext, IErrorsContext } from './ErrorsContext';

const useErrors = (): IErrorsContext => useContext(ErrorsContext);

export default useErrors;
